<template>
  <div class="carousel" v-bind:class="{ 'mob-carousel':mobCarouselStyle, 'hiyamizu-style':hiyamizuStyle }">
    <div class="slide">
        <svg class="slide__arrow-img slide-left__arrow-img" v-on:click="prev" version="1.1" id="arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 27.1 51.4" style="enable-background:new 0 0 27.1 51.4;" xml:space="preserve">
          <g id="arrow_1_">
            <polygon points="1.4,51.4 0,50 24.3,25.7 0,1.4 1.4,0 27.1,25.7 	"/>
          </g>
        </svg>
        <!-- <img class="slide__arrow-img slide-left__arrow-img" 
            src="/assets/img/project/carousel_arrows.svg"
            v-on:click="prev"
        > -->
      <transition-group tag="div" class="slide__img-area" :name="style">
        <div v-for="number in [currentImg]" 
            v-bind:key="number" v-on:touchstart="carouselTouchstart"
            v-on:touchmove="carouselTouchmove"
            v-on:touchend="carouselTouchend"
        >
          <img ref="mobileSlideImg" class="works__list__img slide__img-main"
            v-bind:src="getImgUrl(imgList[Math.abs(currentImg) % imgList.length])"
          >   
        </div>
      </transition-group>
        <svg class="slide__arrow-img slide-right__arrow-img" v-on:click="next" version="1.1" id="arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 27.1 51.4" style="enable-background:new 0 0 27.1 51.4;" xml:space="preserve">
          <g id="arrow_1_">
            <polygon points="1.4,51.4 0,50 24.3,25.7 0,1.4 1.4,0 27.1,25.7 	"/>
          </g>
        </svg>
      <!-- <img class="slide__arrow-img slide-right__arrow-img" src="/assets/img/project/carousel_arrows.svg" v-on:click="next"> -->
    <p class="carousel__credit">{{ imgCredit }}</p>
    <div class="carousel__footer">
      <span class="carousel__footer-dot font__roboto" v-for="(number, index) in imgList.length" v-bind:key="number" v-bind:class="{'is-active':index == (Math.abs(currentImg) % imgList.length)}">●</span>
    </div>
    </div>
  </div>
</template>
<script>
import projectImgList from '../../../public/project_img_list.json'
export default {
  name: "Carousel",
  // 親から受け取るデータ
  props: {
    selectTagKey: String,
  },
  data() {
    return {
      // 冷や水ページカルーセルスタイル
      hiyamizuStyle: false,
      // srcImgUrlのjsonデータ
      projectImgList,
      // カルーセル用の画像srcリスト
      imgList: [],
      // カルーセル表示中画像の配列番号
      currentImg: 0,
      // img内の親ディレクトリ
      CarouselImgFolder: "",
      // imgのsrcパス
      imgUrl: "",
      // 写真のクレジット
      imgCredit: "",
      style: '',
      key: 0,
      // モバイルスタイル
      mobCarouselStyle: false,
      // モバイル用カルーセル
      startX: 0,
      moveX: 0,
      dist: 10
    };
  },
  created: function() {
    // カルーセル用の画像srcリスト初期化 
    this.imgList = []
    // 冷や水ページの写真
    if(this.selectTagKey === 'hiyamizu'){
      this.hiyamizuStyle=true,
      this.CarouselImgFolder = 'hiyamizu/'
      this.imgList.push('hiyamizu_01.jpg')
      this.imgList.push('hiyamizu_02.jpg')
    } else {
      // プロジェクトごとの写真
      this.CarouselImgFolder = 'project/'
      for (var item in this.projectImgList) {
        if(this.selectTagKey === item){
          // カルーセル用の画像srcリストに格納
          this.imgList = this.projectImgList[item].src_url
          // 写真クレジット格納
          this.imgCredit = this.projectImgList[item].img_credit
        }
      }
    }
    /**
     * モバイル時のフォーカス処理
     */
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('Android') > 0) {
      this.mobCarouselStyle = true
    } else {
      this.mobCarouselStyle = false
    }
  },
  methods: {
    next:function() {
      this.currentImg++;
      this.style="slide-next"
      },
    prev:function() {
      this.currentImg--;
      this.style="slide-prev"
      },
    getImgUrl(imgUrl) {
      var imgSrc = "/assets/img/" + this.CarouselImgFolder + imgUrl
      return imgSrc
    },
    /**
     * モバイルのカルーセル切替スクリーンタッチ処理
     */
    // スクリーンタッチスタート位置取得
    carouselTouchstart:function(e) {
      this.startX = e.touches[0].pageX;
    },
    // スクリーンタッチムーブ距離取得
    carouselTouchmove:function(e) {
      this.moveX = e.changedTouches[0].pageX;
    },
    // スクリーンタッチ終了時処理
    carouselTouchend() {
      // 右から左へスワイプ
      if ( this.startX > this.moveX || this.startX > this.moveX + this.dist ) {
      this.currentImg++;
      this.style="slide-next"
      } else if ( this.startX < this.moveX || this.startX + this.dist < this.moveX ) {
        this.currentImg--;
        this.style="slide-prev"
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// モバイル用カルーセルスタイル
.mob-carousel.carousel {
  width: 100%;
  margin: 0;
  padding-top: 40px;
  padding-bottom: 40px;
} 
.mob-carousel {
  .slide__img-area {
    height: 80.5vw;
    width: 100%;
    margin: 0;
  }
  .slide__img-main {
    object-fit: contain;
    width: 100%;
    height: 80.5vw;
  }
  .slide__arrow-img {
    display: none;
  }
  .carousel__credit {
    margin-left: 10vw;
  }
}


.carousel {
  padding-top: 40px;
  padding-bottom: 40px;
}
.slide {
  position: relative;
}
// 矢印
.slide__arrow-img {
  position: absolute;
  // display: inline-block;
  width: 2.5vw;
}
.slide-left__arrow-img  {
  -webkit-transform: scale(-1, 1);
  transform: scale(-1, 1); 
  top: 22vw;
  left: 6vw; 
}
.slide-right__arrow-img  {
  top: 22vw;
  right: 6vw;
}
// 写真サイズ
.slide__img-area {
  overflow: hidden;
  position: relative;
  height: 47vw;
  width: 70.5vw;
  left: 50%;
  transform: translateX(-50%);
}
.slide__img-main {
  object-fit: contain;
  width: 100%;
  height: 47vw;
  overflow: hidden;
  position:absolute;
  top:0;
  bottom:0;
  left:0;
}
// 写真枚数表示
.carousel__footer-dot {
  font-size: 10px;
  margin: 0.2vw;
  color: #c8c8c8;
  &.is-active {
    color: #000000;
  }
}
.slide-next-leave-active,
.slide-next-enter-active, 
.slide-prev-leave-active,
.slide-prev-enter-active {
  transition: 0.8s;
}
.slide-next-enter, 
.slide-prev-leave-to {
  transform: translate(100%, 0);
}
.slide-next-leave-to,
.slide-prev-enter {
  transform: translate(-100%, 0);
}
// クレジット
.carousel__credit {
  width: 70.5vw;
  margin: 0 auto;
  font-size: 10px;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 15px;
}
.carousel__footer {
  text-align: center;
}

// 冷や水ページ独自スタイル
.carousel.hiyamizu-style {
  padding-top: 0px;
  padding-bottom: 0px;
  .slide {
    position: relative;
    // nzStyle
    // height: 68vw;
    height: 67vw;
    width: 100vw;
    background: #ffffff;
  }
  .slide__img-area {
    // nzStyle
    // 写真サイズ2:3(若干横長)
    // height: 60vw;
    height: 67vw;
    width: 100vw;
  }
  .slide__arrow-img {
    // position: absolute;
    fill:#C5C5C5;
    top: 48%;
    transform: translateY(-48%);
  }
  .slide-left__arrow-img  {
    z-index: 10;
    left: 2%;
    -webkit-transform: scale(-1, 1);
    transform: scale(-1, 1);  
  }
  .slide-right__arrow-img {
    right: 2%;
  }
  .slide__img-main {
    object-fit: contain;
    width: 100%;
    height: auto;
    position:absolute;
    // margin: 0 auto;
  }
  // 写真枚数表示
  .carousel__footer {
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translate(-50%,0);
  }
}
@media screen and (min-width: 768px) { 
  .carousel {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .slide {
    position: relative;
  }
  // 矢印
  .slide__arrow-img {
    position: absolute;
    // display: inline-block;
    width: 1.8vw;
  }
  .slide-left__arrow-img  {
    -webkit-transform: scale(-1, 1);
    transform: scale(-1, 1); 
    top: 15vw;
    left: 20vw; 
  }
  .slide-right__arrow-img  {
    top: 15vw;
    right: 20vw;
  }
  // 写真サイズ
  .slide__img-area {
    overflow: hidden;
    position: relative;
    height: 33.8vw;
    width: 50.4vw;
    left: 50%;
    transform: translateX(-50%);
  }
  .slide__img-main {
    object-fit: contain;
    width: 100%;
    height: 33.8vw;
    overflow: hidden;
    position:absolute;
    top:0;
    bottom:0;
    left:0;
  }
  // クレジット
  .carousel__credit {
    width: 50.4vw;
    margin: 0 auto;
    font-size: 10px;
  }
  .carousel__footer {
    text-align: center;
  }
  // 冷や水スタイル
  .carousel.hiyamizu-style {
  .slide {
    // nzStyle
    // height: 55vw;
    height: 67vw;
  }
  .slide__img-area {
    // 写真サイズ2:3(若干横長)
    height: 55vw;
  }
    // 写真枚数表示
    .carousel__footer {
      bottom: 3%;
      left: 50%;
      transform: translate(-50%,3%);
    }
    .slide__img-area {
      // nzStyle
    // 写真サイズ2:3(若干横長)
    // height: 55vw;
    height: 67vw;
    width: 100vw;
  }
  }
}

// .carousel {
//   width: 87%;
//   margin: 0 auto;
//   padding-top: 40px;
//   padding-bottom: 40px;
// }
// .carousel__credit {
//   margin-left: 10%;
//   font-size: 12px;
// }
// .slide {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }
// .slide__arrow-img {
//   // 矢印サイズ
//   width: 3%;
// }
// .slide__img-area {
//   overflow: hidden;
//   position: relative;
//   height: 50vw;
//   width: 69.5vw;
//   background:white;
//   margin: 0 5%;
// }
// .slide__img-main {
//   object-fit: contain;
//   width: 100%;
//   height: 50vw;
//   overflow: hidden;
//   position:absolute;
//   top:0;
//   bottom:0;
//   left:0;
// }
// .slide-next-leave-active,
// .slide-next-enter-active, 
// .slide-prev-leave-active,
// .slide-prev-enter-active {
//   transition: 0.8s;
// }
// .slide-next-enter, 
// .slide-prev-leave-to {
//   transform: translate(100%, 0);
// }
// .slide-next-leave-to,
// .slide-prev-enter {
//   transform: translate(-100%, 0);
// }
// .carousel__footer {
//   text-align: center;
// }
// .carousel__footer-dot {
//   font-size: 10px;
//   margin: 0.2vw;
//   color: #c8c8c8;
//   &.is-active {
//     color: #000000;
//   }
// }
// // PC
// @media screen and (min-width: 768px) {
//   .carousel {
//     width: 60%;
//     padding-top: 80px;
//     padding-bottom: 80px;
//   }
//   .carousel__credit {
//     margin-left: 8%;
//     font-size: 10px;
//   }
//   .slide__arrow-img {
//     width: 3%;
//   }
//   .slide__img-area {
//     height: 34vw;
//     width: 52.5vw;
//     margin: 0 5%;
//   }
//   .slide__img-main {
//     width: 100%;
//     height: 34vw;
//   }
//   .carousel__footer-dot {
//     font-size: 0.6vw;
//     margin: 0.2vw;
//   }
// }


</style>